import React, { useState } from "react";
import CreateCareerPost from "./CreateCareerPost";
import BrowseCareer from "./BrowseCareer";

function Career() {
  const [tabstatus, setTabStatus] = useState("create");

  return (
    <div
      style={{
        padding: "32px",
        maxWidth: "1400px",
        margin: "0",
      }}
    >
      {/* Tabs */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          marginBottom: "24px",
          borderBottom: "1px solid #e2e8f0",
          paddingBottom: "8px",
        }}
      >
        <button
          onClick={() => setTabStatus("create")}
          style={{
            padding: "10px 18px",
            borderRadius: "10px",
            background: tabstatus === "create" ? "#e8efff" : "transparent",
            color: tabstatus === "create" ? "#1e3a8a" : "#475569",
            border: "none",
            fontWeight: tabstatus === "create" ? 600 : 500,
            fontSize: "15px",
            cursor: "pointer",
            transition: "all .25s ease",
          }}
        >
          Create Career Post
        </button>
        <button
          onClick={() => setTabStatus("browse")}
          style={{
            padding: "10px 18px",
            borderRadius: "10px",
            background: tabstatus === "browse" ? "#e8efff" : "transparent",
            color: tabstatus === "browse" ? "#1e3a8a" : "#475569",
            border: "none",
            fontWeight: tabstatus === "browse" ? 600 : 500,
            fontSize: "15px",
            cursor: "pointer",
            transition: "all .25s ease",
          }}
        >
          Browse Existing Career Posts
        </button>
      </div>

      {/* Card Container */}
      <div
        style={{
          background: "#ffffff",
          borderRadius: "14px",
          padding: "28px",
          boxShadow: "0 3px 20px rgba(0,0,0,0.06)",
          border: "1px solid #e5e7eb",
        }}
      >
        {tabstatus === "create" ? <CreateCareerPost /> : <BrowseCareer />}
      </div>
    </div>
  );
}

export default Career;
